<div class="container">
    <div class="card">
        <div class="card-corner-badge">
            <ng-content select="[fcpTileCardBadge]"></ng-content>
        </div>
        <div *ngIf="properties.variant === getCardVariant('SINGLE_TEXT')" class="card-container single-text">
            <label class="card-center-label">
                {{ properties.imgLabel }}
            </label>
        </div>

        <div
            *ngIf="
                properties.variant === getCardVariant('IMAGE_TEXT_LIGHT') ||
                properties.variant === getCardVariant('IMAGE_TEXT_DARK')
            "
            class="card-container image-text"
        >
            <img src="{{ properties.imageList[0] }}" class="card-center-image" />
            <label class="card-bottom-label">{{ properties.imgLabel }}</label>
            <div
                *ngIf="properties.variant === getCardVariant('IMAGE_TEXT_LIGHT')"
                class="card-container-light-overlay"
            ></div>
        </div>

        <div
            *ngIf="properties.variant === getCardVariant('SINGLE_IMAGE')"
            class="card-container single-image"
            [ngStyle]="{ 'background-image': 'url(' + properties.coverImg + ')' }"
        ></div>

        <div
            *ngIf="properties.hoverMode !== 'none'"
            class="card-hover-overlay"
            [ngClass]="{ light: properties.hoverMode === 'light' }"
        >
            <div [ngClass]="{ 'card-hover-overlay-corner-badge': properties.actionsList.length > 0 }">
                <ng-content select="[fcpTileCardHoverBadge]"></ng-content>
            </div>
            <div *ngFor="let button of buttonsInfo">
                <button
                    *ngIf="button.type === 'primary'"
                    fcp-button
                    class="card-hover-overlay-action-button"
                    (click)="onButtonClick($event, button.key)"
                >
                    {{ button.label }}
                </button>

                <button
                    *ngIf="button.type === 'outlined'"
                    fcp-outlined-button
                    class="card-hover-overlay-action-button"
                    (click)="onButtonClick($event, button.key)"
                >
                    {{ button.label }}
                </button>
            </div>
        </div>
    </div>
</div>
